import React, { useState, useEffect } from "react";
import VariantBrowserPage from "./components/pages/VariantBrowserPage";
import Header from "./components/layout/Header";
import FileUploaderPage from "./components/pages/FileUploaderPage";
import LoginPage from "./components/pages/LoginPage";

function App() {
  // Real authentication state - no auto-login
  const [auth, setAuth] = useState({
    isLoading: false,
    error: null,
    isAuthenticated: false,
    user: null
  });

  // Handle authentication
  const handleAuthenticate = (userData) => {
    const newAuth = {
      isLoading: false,
      error: null,
      isAuthenticated: true,
      user: {
        profile: { email: userData.email },
        access_token: userData.token
      }
    };

    setAuth(newAuth);
    localStorage.setItem('auth', JSON.stringify({ user: newAuth.user }));
  };

  const [isFileUploaded, setIsFileUploaded] = useState(true);
  const [sidebarVisible, setSidebarVisible] = useState(() => {
    // Start with sidebar hidden on mobile
    return window.innerWidth >= 768;
  });
  const [fileChangeKey, setFileChangeKey] = useState(0);



  // Listen for automatic sign-out events (e.g. from 401s)
  useEffect(() => {
    const handleUnauthorized = () => {
      signOutRedirect();
    };

    window.addEventListener('auth:unauthorized', handleUnauthorized);
    return () => {
      window.removeEventListener('auth:unauthorized', handleUnauthorized);
    };
  }, []);


  const signOutRedirect = () => {
    // Clear authentication state and localStorage
    setAuth({
      isLoading: false,
      error: null,
      isAuthenticated: false,
      user: null
    });
    localStorage.removeItem('auth');
  };

  const showUpload = () => {
    setIsFileUploaded(false);
  };

  const toggleSidebar = () => {
    setSidebarVisible((prev) => !prev);
  };

  const handleFileSwitch = () => {
    // Trigger refresh of all components that depend on file data
    setFileChangeKey(prev => prev + 1);
    setIsFileUploaded(true);
  };

  if (auth.isLoading) {
    return <div>Loading...</div>;
  }

  if (auth.error) {
    return <div>Error: {auth.error.message}</div>;
  }

  if (auth.isAuthenticated) {
    return (
      <div>
        {/* <pre>Welcome, {auth.user?.profile.email}</pre> */}

        {isFileUploaded ? (
          <div
            className="fade-in"
            style={{
              height: "100vh",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Header
              email={auth.user?.profile.email}
              signOutRedirect={signOutRedirect}
              showUpload={showUpload}
              toggleSidebar={toggleSidebar}
              sidebarVisible={sidebarVisible}
            />
            <div style={{ flex: 1, overflow: "hidden" }}>
              <VariantBrowserPage
                key={fileChangeKey}
                token={auth.user?.access_token}
                sidebarVisible={sidebarVisible}
                toggleSidebar={toggleSidebar}
              />
            </div>
          </div>
        ) : (
          <div className="fade-in">
            <FileUploaderPage
              onFileSelected={handleFileSwitch}
              signOutRedirect={signOutRedirect}
              token={auth.user?.access_token}
            />
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="bounce-in">
      <LoginPage onAuthenticate={handleAuthenticate} />
    </div>
  );
}

export default App;
